<template>
    <div class="crumbs" v-if="crumbsVisible">
        <div class="title" v-if="$route.meta.title != '首页概览'">
            {{$route.meta.title}}
        </div>
    </div>
</template>
<script>
export default {
    name: 'BreadCrumb',
    data() {
        return {};
    },
    computed: {
        crumbsVisible() {
            return this.$route.meta.title !== '平台首页' && this.$route.meta.title !== '404';
        }
    }
};
</script>
<style lang="less" scoped>
    .crumbs {
        position: relative;
        height: 0px;

        .title {
            position: absolute;
            top: 3px;
            left: 8px;
            font-size: 18px;
            font-weight: 700;
            line-height: 1.5;
            width: 128px;
            height: 30px;
        }
    }
</style>
